// extracted by mini-css-extract-plugin
export default {"sinPermisoDiv":"SinPermisoComponent_sinPermisoDiv__wUHuW"};